import { cn } from '../utils/cn';
import { ChevronDown } from 'lucide-react';
import type { SelectOption } from '../types';

interface SelectInputProps {
  label: string;
  name: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLSelectElement>) => void;
  options: SelectOption[];
  placeholder?: string;
  error?: string;
  required?: boolean;
  disabled?: boolean;
  className?: string;
}

export default function SelectInput({
  label, name, value, onChange, onBlur, options, placeholder, error, required, disabled, className,
}: SelectInputProps) {
  return (
    <div className={cn('space-y-1', className)}>
      <label htmlFor={name} className="block text-xs font-medium text-content-secondary">
        {label} {required && <span className="text-danger">*</span>}
      </label>
      <div className="relative">
        <select
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          className={cn(
            'w-full appearance-none rounded-lg border px-3 py-2 pr-8 text-sm text-content-primary bg-surface-card outline-none transition-colors',
            error ? 'border-danger' : 'border-border focus:border-primary focus:ring-1 focus:ring-primary',
            disabled && 'opacity-50 cursor-not-allowed',
            !value && 'text-content-muted'
          )}
        >
          {placeholder && <option value="">{placeholder}</option>}
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
        <ChevronDown size={14} className="absolute right-2.5 top-1/2 -translate-y-1/2 text-content-muted pointer-events-none" />
      </div>
      {error && <p className="text-xs text-danger">{error}</p>}
    </div>
  );
}
